import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import api from "../lib/api";
import { useStore } from "../lib/store";

export default function Account() {
  const { user, logout, authLoading } = useStore();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) api.get("/orders/me").then((r) => setOrders(r.data));
  }, [user]);

  if (authLoading) return <div className="container-kv pt-32 pb-20">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="container-kv pt-28 pb-20" data-testid="account-page">
      <div className="flex items-center justify-between mb-10">
        <div>
          <div className="overline mb-2">Your Account</div>
          <h1 className="font-serif text-4xl font-light">Hello, {user.name}</h1>
          <p className="text-[#A8A5A1] text-sm mt-1">{user.email}</p>
        </div>
        <button onClick={logout} className="btn-ghost" data-testid="logout-btn">
          <LogOut size={14} /> Sign out
        </button>
      </div>

      {user.role === "admin" && (
        <div className="card-kv mb-8 border-[#C8A97E]/30">
          <div className="overline mb-2">Admin</div>
          <Link to="/admin" className="text-[#C8A97E] hover:underline">Open admin dashboard →</Link>
        </div>
      )}

      <div className="card-kv">
        <h2 className="font-serif text-2xl mb-5">Your orders</h2>
        {orders.length === 0 ? (
          <div className="text-[#75726D] text-sm py-8 text-center" data-testid="orders-empty">
            No orders yet.{" "}
            <Link to="/shop" className="text-[#C8A97E] hover:underline">Start shopping</Link>
          </div>
        ) : (
          <div className="divide-y divide-white/5">
            {orders.map((o) => (
              <div key={o.id} className="py-5 grid sm:grid-cols-5 gap-3 text-sm" data-testid={`order-${o.id.slice(0,8)}`}>
                <div className="font-mono text-xs text-[#A8A5A1]">{o.id.slice(0, 8).toUpperCase()}</div>
                <div className="text-[#A8A5A1]">{new Date(o.created_at).toLocaleDateString()}</div>
                <div>{o.lines.length} item{o.lines.length > 1 ? "s" : ""}</div>
                <div>${o.total.toFixed(2)}</div>
                <div>
                  <span className={`text-xs px-2 py-1 ${o.payment_status === "paid" ? "text-[#4ADE80] border border-[#4ADE80]/30" : "text-[#FCA5A5] border border-[#FCA5A5]/30"}`}>
                    {o.payment_status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
